<template>
	<div class="layer" data-size="small">
		<div class="top" :style="[{'background-color': headerColor}]">
			<div @click="closeDialog()" class="close icon fastic-close" :style="[{'color': menuColor}]"></div>
			<div class="title" :style="[{'color': menuColor}]">{{ localizer.get("PrivateArea.Common.Asset_ProfileRelationList_Title") }}</div>
		</div>
		<div class="content">
			<div class="add form">
				<div class="label">{{ localizer.get("PrivateArea.Common.Asset_ProfileRelationList_SetProfileRelation_Label") }}</div>
				<template v-if="userProfile.isDirectLink">
					<div class="item">
						<div class="checkbox" data-info>
							<div class="label">
								<input type="checkbox" id="IsDirectLink" v-model.lazy="formData.isDirectLink" class="checkbox" />
								<label for="IsDirectLink">{{ localizer.get("PrivateArea.Common.DirectLink_Label") }}</label>
							</div>
							<div class="info">
								<span class="icon fastic-info"></span>
								<div class="tooltip">{{ localizer.get("PrivateArea.Common.DirectLink_Tooltip") }}</div>
							</div>
						</div>
					</div>
				</template>
				<div class="item">
					<div class="input">
						<input type="text" id="Email" v-model.lazy="formData.email" :disabled="formData.isDirectLink === true" :placeholder="localizer.get('PrivateArea.Common.Asset_ProfileRelationList_EmailPlaceholder')" :class="[{'input-validation-error': isValidationError('Email')}, 'textbox']" />
					</div>
				</div>
				<div class="item">
					<div class="input">
						<label for="ExpirationDays">{{ localizer.get("PrivateArea.Common.Expiration") }}</label>
						<select id="ExpirationDays" v-model="formData.expirationDays" :class="[{'input-validation-error': isValidationError('ExpirationDays')}, 'dropdown']">
							<option v-for="(expirationDay, index) in userProfile.expirationDays" :key="index" :value="expirationDay.value">
								{{ expirationDay.title }}
							</option>
						</select>
					</div>
				</div>
				<div v-if="!isPrivateDisabled && formData.isDirectLink !== true" class="item">
					<div class="checkbox" data-info>
						<div class="label">
							<input type="checkbox" id="IsPrivate" :disabled="isPrivateDisabled" v-model.lazy="formData.isPrivate" :class="[{'input-validation-error': isValidationError('IsPrivate')}, 'checkbox']" />
							<label for="IsPrivate">{{ localizer.get("PrivateArea.Common.RequestLogin") }}</label>
						</div>
						<div class="info">
							<span class="icon fastic-info"></span>
							<div class="tooltip">{{ localizer.get("PrivateArea.Common.PrivateDescriptionTooltip") }}</div>
						</div>
					</div>
				</div>
				<div v-if="userProfile.isProfileBranding && userProfile.companyName" class="item">
					<div class="checkbox" data-info>
						<div class="label">
							<input type="checkbox" id="IsProfileBranding" v-model.lazy="formData.isProfileBranding" :class="[{'input-validation-error': isValidationError('IsProfileBranding')}, 'checkbox']" />
							<label for="IsProfileBranding">{{ localizer.get("PrivateArea.Common.ProfileBranding", userProfile.companyName) }}</label>
						</div>
						<div class="info">
							<span class="icon fastic-info"></span>
							<div class="tooltip">{{ localizer.get("PrivateArea.Common.ProfileBrandingTooltip") }}</div>
						</div>
					</div>
				</div>
				<div v-if="userProfile.isReasonActive" class="item">
					<div class="input">
						<label for="Reason">{{ localizer.get("PrivateArea.Common.Reason") }}</label>
						<textarea id="Reason" v-model.lazy="formData.reason" :placeholder="localizer.get('PrivateArea.Common.ProfileRelationList_Causal_Placeholder')" :class="[{'input-validation-error': isValidationError('Reason')}, 'textarea']"></textarea>
					</div>
				</div>
				<div v-if="formData.isDirectLink !== true" class="item">
					<div class="input">
						<textarea id="MessageNotes" v-model.lazy="formData.messageNotes" :placeholder="localizer.get('PrivateArea.Common.ProfileRelationList_Notes_Placeholder')" :class="[{'input-validation-error': isValidationError('MessageNotes')}, 'textarea']"></textarea>
					</div>
				</div>
				<template v-if="formData.isPrivate">
					<div class="item">
						<div class="message">
							<span class="icon fastic-info"></span>
							<span class="text">{{ localizer.get("PrivateArea.Common.PrivateDefault") }}</span>
						</div>
					</div>
				</template>
				<div class="item">
					<div v-if="!isLoading" @click="setProfileRelation()" class="button" :style="[{'background-color': accentColor}]">
						<template v-if="formData.isDirectLink !== true">
							{{ localizer.get("PrivateArea.Common.Asset_ProfileRelationList_SetProfileRelation_Button") }}
						</template>
						<template v-else>
							{{ localizer.get("PrivateArea.Common.GenerateLink") }}
						</template>
					</div>
					<div v-else class="button load" :style="[{'background-color': accentColor}]"><div class="loader"></div></div>
				</div>
				<div v-if="userProfile.isBundleEmail" class="bundle">
					<div v-if="emailBundleIds.some(x => x === assetIdMaster)" class="notify">
						<span class="success">
							<span class="marker"><span class="icon fastic-check"></span></span>
							{{ localizer.get("PrivateArea.Common.Bundle_AddButton") }}
						</span>
						<span @click="setBundleEmail()" class="remove">{{ localizer.get("PrivateArea.Common.Remove") }}</span>
					</div>
					<div v-else @click="setBundleEmail()" class="button">{{ localizer.get("PrivateArea.Common.Bundle_AddedTitle") }}</div>
				</div>
				<div v-if="validationErrors.length !== 0" class="validation-summary-errors">
					<ul>
						<li v-for="(validationError) in validationErrors" :key="validationError.name">{{ validationError.message }}</li>
					</ul>
				</div>
			</div>
			<div class="list-user">
				<div class="title">{{ localizer.get("PrivateArea.Common.ProfileRelationList_Title") }}</div>
				<div v-for="(projectProfile) in projectProfiles" :key="projectProfile.email" class="item">
					<div class="info">
						<div class="label">{{ localizer.get("PrivateArea.Common.Asset_ProfileRelationList_Admin") }}</div>
						<div class="name">{{ projectProfile.email }}</div>
					</div>
				</div>
				<div v-for="(profileRelation) in profileRelations" :key="profileRelation.idMaster" class="item">
					<div class="info">
						<div class="label">{{ localizer.get("PrivateArea.Common.Asset_ProfileRelationList_Guest") }}<span v-if="profileRelation.isPrivate" class="icon fastic-lock"></span></div>
						<div class="name">{{ profileRelation.email }}</div>

						<div class="info">
							<div>{{ localizer.get("PrivateArea.Common.CreatedBy") }}: {{ profileRelation.authorDescription }}</div>
							<div v-if="userProfile.isReasonActive && profileRelation.reason">{{ localizer.get("PrivateArea.Common.Reason") }}: {{ profileRelation.reason }}</div>
							<div v-if="profileRelation.isExpirationDate">{{ localizer.get("PrivateArea.Common.ProfileRelation_ExpirationDate", formatDate(profileRelation.expirationDate)) }}</div>
							<div><a :href="profileRelation.linkUrl" target="_black" @click="renderShareAnalytics(profileRelation.linkUrl)" class="link">{{ localizer.get("PrivateArea.Common.RenderLink") }}</a></div>
						</div>

						<div v-if="profileRelation.assetViewedCounter != 0" class="status">
							<span class="view">
								<template v-if="profileRelation.assetViewedCounter === 1">
									{{ localizer.get("PrivateArea.Common.ProfileRelationList_IsAssetViewed_Label") }}
								</template>
								<template v-else>
									<span class="count">{{ profileRelation.assetViewedCounter }}</span> {{ localizer.get("PrivateArea.Common.ProfileRelationList_AssetViewedCounter_Label") }}
								</template>
								({{ formatDate(profileRelation.assetViewedLastDate) }} {{ localizer.get("PrivateArea.Common.ProfileRelationList_AssetViewedLastTime_Label") }} {{ formatTime(profileRelation.assetViewedLastDate) }})
							</span>
						</div>
					</div>
					<div class="copy">
						<span class="icon fastic-link"></span>
						<span @click="copyToClipboard(profileRelation.linkUrl)" class="label">{{ localizer.get("PrivateArea.Common.CopyLink") }}</span>
					</div>
					<div class="remove" @click="removeProfileRelation(profileRelation.idMaster)">{{ localizer.get("PrivateArea.Common.Asset_ProfileRelationList_RemoveProfileRelation_Button") }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
	projectIdMaster: string;
	assetIdMaster: string;
	accentColor: string;
	headerColor: string;
	menuColor: string;
}>();

const store = useStore();
const localizer = Localizer;
const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({ isPrivate: false, isProfileBranding: false });
const validationErrors = ref<any[]>([]);
const userProfile = ref<any>({ expirationDay: [], shareModes: [], isDirectLink: false, isBundleEmail: false });
const projectProfiles = ref<any[]>([]);
const profileRelations = ref<any[]>([]);
const isPrivateDisabled = ref(false);
const routes = (window as any).App.routes;

const emailBundleIds = computed(() => store.getters["privateAreaBundleEmailStore/emailBundleIds"]);

onMounted(() => {
	getProfileRelations();
});

async function getProfileRelations() {
	let response = (await Axios.post(routes.PrivateArea_Asset_GetProfileRelations, { projectIdMaster: props.projectIdMaster, assetIdMaster: props.assetIdMaster })).data;

	userProfile.value = response.userProfile;
	projectProfiles.value = response.projectProfiles;
	profileRelations.value = response.profileRelations;

	if (userProfile.value.shareModes.length === 1) {
		isPrivateDisabled.value = true;
	}

	formData.value.expirationDays = userProfile.value.expirationDays[0].value;
}

async function setProfileRelation() {
	validationErrors.value = [];

	isLoading.value = true;

	formData.value.projectIdMaster = props.projectIdMaster;
	formData.value.assetIdMaster = props.assetIdMaster;

	let successMessage = formData.value.isDirectLink ? localizer.get("PrivateArea.Common.GenerateLink_Success") : localizer.get("PrivateArea.Common.Asset_ProfileRelationList_SetProfileRelation_Success");
	try {
		await Axios.post(routes.PrivateArea_Asset_SetProfileRelation, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

		let requestLogin = formData.value.isPrivate ? "login" : "public";

		GTagHelper.sendEvent("form_submit", "render_share", formData.value.expirationDays + "_" + requestLogin, 1);

		formData.value = {};

		isSuccess.value = true;

		store.dispatch("accountAreaToastStore/onAddToast", { message: successMessage, type: "Success" });

		getProfileRelations();
	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
	}

	isLoading.value = false;
}

async function removeProfileRelation(profileRelationIdMaster: string) {
	var result = confirm(localizer.get("PrivateArea.Common.Asset_RemoveProfileRelation_Confirm"));
	if (result) {
		try {
			await Axios.post(routes.PrivateArea_Asset_RemoveProfileRelation, { projectIdMaster: props.projectIdMaster, assetIdMaster: props.assetIdMaster, profileRelationIdMaster: profileRelationIdMaster }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

			store.dispatch("accountAreaToastStore/onAddToast", { message: localizer.get("PrivateArea.Common.Asset_ProfileRelationList_RemoveProfileRelation_Success"), type: "Success" });

			GTagHelper.sendEvent("click", "render_share", "remove");

			getProfileRelations();
		} catch (error) {
			if (error.response && error.response.status === 400) {
				let validationErrors = FormHelper.getValidationErrors(error.response.data);
				if (validationErrors.length !== 0) {
					store.dispatch("accountAreaToastStore/onAddToast", { message: validationErrors[0].message, type: "Error" });
				}
			}
		}
	}
}

function renderShareAnalytics(renderLinkURL: string) {
	GTagHelper.sendEvent("click", "render_share", "link");
}

function setBundleEmail() {
	if (emailBundleIds.value.some(x => x === props.assetIdMaster)) {
		store.commit("privateAreaBundleEmailStore/setEmailBundleIds", emailBundleIds.value.filter(x => x !== props.assetIdMaster));
	} else {
		store.commit("privateAreaBundleEmailStore/setEmailBundleIds", [...emailBundleIds.value, props.assetIdMaster]);
	}

	store.dispatch("privateAreaBundleEmailStore/saveEmailBundleIds");
}

function closeDialog() {
	let assetShareBox = document.getElementById("AssetShareBox"),
		body = document.getElementsByTagName("body")[0];

	if (assetShareBox && !assetShareBox.classList.contains("hden")) {
		assetShareBox.classList.add("hden");

		if (body.hasAttribute("data-overflow")) {
			body.removeAttribute("data-overflow");
		}
	}
}

function copyToClipboard(profileRelationLinkUrl: string) {
	navigator.clipboard.writeText(window.location.origin + profileRelationLinkUrl);
	store.dispatch("accountAreaToastStore/onAddToast", { message: localizer.get("PrivateArea.Common.Asset_ProfileRelationList_CopyClipboard_Success"), type: "Success" });
}

function formatDate(dateItem: string): string {
	if (dateItem == null) {
		return "";
	}

	let date = new Date(dateItem);
	return date.toLocaleString((<any>window).App.culture, {
		day: "numeric",
		month: "numeric",
		year: "numeric"
	});
}

function formatTime(dateItem: string): string {
	if (dateItem == null) {
		return "";
	}

	let date = new Date(dateItem);
	return date.toLocaleString((<any>window).App.culture, {
		hour: "numeric",
		minute: "2-digit"
	});
}

function isValidationError(controlName: string): boolean {
	return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>